/* eslint-disable react/no-danger */
import React, { useState, useEffect,useRef } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import './LogComponent.scss';
import swal from 'sweetalert';
import { httpGet, httpGetFile, httpPost } from '../../../store/externalCalls/httpCalls';
import LogPagination from './LogPagination';
import LogTabs from './LogTabs';
import LogFilter from './LogFilter';
import LogRealTime from './LogRealTime';

const LogComponent = (props) => {
  const {
    dataId,
    initialValues,
    legend,
    clearVisible,
    clearUrl,
    downloadLogUrl,
    generateLogUrl,
    downloadLogs,
    filters,
    logData,
    logDataValues,
    log_link,

  } = props;
  const [values, setValues] = useState([]);
  const [customFilters,setCustomFilters] =useState(null);
  const [logsVisible,setLogsVisible]=useState();
  const [refreshPaginationButton,setRefreshPaginationButton]=useState(false);
  const [pagination,setPagination] =useState(null);
  const [pageSize,setPageSize]= useState(5);
  const [totalLogs,setTotalLogs] = useState(0);
  const [currentPage,setCurrentPage] =useState(1);
  const [activeTabId,setActiveTabId]=useState("1");
  const [timestampOffset,setTimestampOffset] =useState(null);
  const handleLogPageChange=(newPage)=>{
    // console.log(logData,dataId);
    getData(dataId,newPage,customFilters,timestampOffset,(res)=>{
      setLogsVisible(res.data);
      setCurrentPage(newPage);
    });
  }

  const objToQueryParams = (obj, prefix = "") => {
    const queryParams = new URLSearchParams();
    const buildQuery = (data) => {
      for (const key in data) {
        if (typeof data[key] === "object" && data[key] !== null) {
          buildQuery(data[key]);
        } else {
          queryParams.append(`${key}`, data[key]);
        }
      }
    };
  
    buildQuery(obj, prefix);
    return queryParams.toString();
  };

  const getData=async (dataId,newPage,filters,timestampOffset,onFinish)=>{
    let url=logData.getUrl+dataId+"/"+newPage;
    // console.log(url);
    if(filters){
      let queryParams=objToQueryParams(filters);
      url+="?"+queryParams+"&timestamp="+timestampOffset;
    }else{
      url+="?timestamp="+timestampOffset;
      // console.log("no filter ");
    }
    const res = await httpGet(url);
    onFinish(res);
    
  }
  const generateLog=(value)=>{
    let location=window.location.pathname;
    let locationArr = location.split("/");
    let eventId=locationArr[locationArr.length-1];
    let params={'id':eventId,'value':value};
    httpPost(generateLogUrl, params).then((res)=>{
      console.log("ok");
    }).catch(e=>{
      if(e.errors){
        swal(e.message, JSON.stringify(e.errors),'error');
      }
    });
  }
  const downloadLog=(value)=>{
    console.log("download log"+downloadLogUrl);
    let location=window.location.pathname;
    let locationArr = location.split("/");
    let eventId=locationArr[locationArr.length-1];
    httpGetFile(downloadLogUrl+"/"+eventId+"/"+value,"Log.csv");
  }

  const handleOnRefreshLogs=()=>{
    // console.log("getData1");
    let newOffset=Date.now();
    getData(dataId,1,customFilters,newOffset,(res)=>{
      setLogsVisible(res.data);
      setCurrentPage(1);
      setPagination(res.pages);
      setTotalLogs(res.total);
      setRefreshPaginationButton(false);
      setTimestampOffset(newOffset);
    });
  }

  const clearLogs=()=>{
    swal({
      title: 'Are you sure?',
      text: "You are about to clear all logs for this event",
      icon: 'warning',
      buttons: {
        cancel: "Cancel",
        butCurrent:"All but current",
        confirm: "Clear all",
      },
      dangerMode: true,
    }).then((result) => {
      let location=window.location.pathname;
      let locationArr = location.split("/");
      let eventId=locationArr[locationArr.length-1];
      let params={'id':eventId};
      if(result){
        if(result=="butCurrent"){
          params.mode='current';
        }else if(result==true){
          params.mode='all';
        }
        httpPost(clearUrl, params).then((res)=>{
            window.location.reload();
        }).catch(e=>{
          if(e.errors){
            swal(e.message, JSON.stringify(e.errors),'error');
          }
        });
      }
    });
  }

  useEffect(() => {
    //start from initial values
    if(Array.isArray(initialValues) && initialValues.length>0){
      setLogsVisible(initialValues);
      setPagination(logDataValues.pages);
      setPageSize(logDataValues.pageSize);
      setCurrentPage(logDataValues.current_page);
      setTotalLogs(logDataValues.total);
      setTimestampOffset(Date.now());
    }
  }, [initialValues]);
  const handleDownloadLink=(e,value)=>{
    e.preventDefault();
    downloadLog(value);
  }
  const handleGenerateLink=(e,value)=>{
    e.preventDefault();
    generateLog(value);
    
  }
  const handleOnFilter=(newFilter)=>{
    setCustomFilters(newFilter);
    getData(dataId,1,newFilter,timestampOffset,(res)=>{
      setLogsVisible(res.data);
      setCurrentPage(1);
      setPagination(res.pages);
      setTotalLogs(res.total);
    });
  }
  const handlerActiveTabId=(tabId)=>{
    // console.log("the active tab is ",tabId);
  }

  const handleOnSocketReceived=()=>{
    setRefreshPaginationButton(true);
  }
  return (
    <div>
      <div>
        {filters && <LogFilter filters={filters} onFilter={handleOnFilter} />}
        <div className="p-4">
          {<LogTabs startingTabId={activeTabId} onActiveTabId={handlerActiveTabId}>
            <LogPagination 
                id="1" 
                label="Historic" 
                refreshPaginationButton={refreshPaginationButton} 
                logs={logsVisible} 
                totalLogs={totalLogs} 
                filters={null} 
                page={currentPage} 
                pages={pagination} 
                pageSize={pageSize} 
                onPageChange={handleLogPageChange} 
                onRefreshLogs={handleOnRefreshLogs}
              />
            <LogRealTime id="2" label="Real TIme Logs" channel={logData.channel} dataId={dataId} filters={customFilters}  onSocket={handleOnSocketReceived} />
          </LogTabs>}
        </div>
        {legend && legend.length>0 && <div className="legend">
          <div>Legend</div>
          {legend.map((el,index)=>(
              <div key={index} className="leyend-item">
                <div className={`logtype logtype--${el.color}`}>{el.letter}</div>
                <div className="leyend-text">{el.text}</div>
              </div>
          ))}
        </div>}
        {clearVisible && <div className="filter-clear"><button  onClick={() => clearLogs()} className='clear-logs'>Clear logs</button></div>}
        <><br/>Logs to download:
        {downloadLogs && log_link && Array.isArray(JSON.parse(log_link)) && JSON.parse(log_link).map((el,index)=>{
            let date="";
            if(el["title"]!="typeMonitor"){
            if(el["date"]!=""){
              date = new Date(parseInt(el["date"])*1000);
              date=format(date,"dd/MM/yyyy HH:ii:ss");
            }
            let entry="";
            let downloaded=" Download log";
            if(el["value"]=="logs"){
              entry="Current-";
              downloaded= " Downloaded current at "+date;
            }else{
              let entryArr=el["value"].split("-");              
              entry = format(entryArr[1]*1000, 'dd/MM/yyyy, H:mma')+"-";
            }
            return (
              <span key={index}>  <br/>
                {el["generated"]=="yes" && <>{entry}<div key={index} className="logs-generate-container"><a className="logs-generate" href="#" onClick={(e)=>{handleGenerateLink(e,el["value"])}}>{"Generate "+el["title"]}</a><button  onClick={(e) => handleDownloadLink(e,el["value"])} className='logs-download'>{"("+el["items"]+")" +downloaded}</button></div></>}
                {el["generated"]=="no" && <>{entry}<a key={index} href="#" onClick={(e)=>{handleGenerateLink(e,el["value"])}}>{"Generate "+el["title"]}</a></>}
                {el["generated"]=="generating" && <>{entry}<a >{"Generating... "+el["title"]}</a></>}
              </span>
            );}
        } )}
        </>
      </div>
    </div>
  );
};

LogComponent.propTypes = {
  title: PropTypes.string.isRequired,
  handlerClose: PropTypes.func,
  legend:PropTypes.array,
  hasFilterText:PropTypes.bool,
  filters:PropTypes.array,
  textNoResults:PropTypes.string,
};

LogComponent.defaultProps = {
  handlerClose: () => {},
  initialValues: [],
  legend:[],
  clearVisible:false,
  clearUrl:null,
  downloadLogUrl:null,
  generateLogUrl:null,
  hasFilterText:false,
  filters:[],
  textNoResults:'',
};

export default LogComponent;
